import { render } from "./NoticeCard.vue?vue&type=template&id=3418c75c&scoped=true"
import script from "./NoticeCard.vue?vue&type=script&lang=js"
export * from "./NoticeCard.vue?vue&type=script&lang=js"

import "./NoticeCard.vue?vue&type=style&index=0&id=3418c75c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3418c75c"]])

export default __exports__